import React from "react";
import MuiButton from "@mui/material/Button";

/**
 * Atom — MUI Button with V2-friendly defaults. Prefer styled `Button` from ./Button when possible.
 */
export function AppButton(props) {
  return (
    <MuiButton
      variant={props.variant ?? "contained"}
      color={props.color ?? "primary"}
      size={props.size ?? "medium"}
      disableElevation
      {...props}
    />
  );
}

export default AppButton;
